/* eslint-disable class-methods-use-this */
(() => {
  class VariantSelectors extends HTMLElement {
    connectedCallback() {
      const variantSelectBtns = this.querySelectorAll(".variant-select-btn");
      variantSelectBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const variantID = btn.getAttribute("data-variant-id");
          this.selectVariant(variantID);
        });
      });

      const variantSwatches = this.querySelectorAll(".variant-swatch");
      variantSwatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          const variantID = swatch.getAttribute("data-variant-id");
          this.selectVariant(variantID);
          this.updateSwatchSelection(swatch);
        });
      });

      this.addEventListener("updatedVariant", (event) => {
        setTimeout(() => {
          this.syncSwatchSelection(event.detail);
        }, 100);
      });

      this.initializeSwatchSelection();
    }

    initializeSwatchSelection() {
      const selectedSwatches = this.querySelectorAll('.variant-swatch--selected');
      selectedSwatches.forEach(swatch => {
        swatch.classList.add('variant-swatch--selected');
      });

      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');
      if (variantParam) {
        this.syncSwatchSelection(variantParam);
      }
    }

    selectVariant(variantID) {
      this.updateQueryString("variant", variantID);

      const eventUpdatedVariant = new CustomEvent("updatedVariant", {
        bubbles: true,
        detail: variantID,
      });
      document.querySelector("p-d-p").dispatchEvent(eventUpdatedVariant);
    }

    updateSwatchSelection(selectedSwatch) {
      const optionName = selectedSwatch.closest('.variant-swatches').getAttribute('data-option-name');
      const swatchGroup = this.querySelector(`[data-option-name="${optionName}"]`);
      
      if (swatchGroup) {
        const allSwatches = swatchGroup.querySelectorAll('.variant-swatch');
        allSwatches.forEach(swatch => {
          swatch.classList.remove('variant-swatch--selected');
        });
        selectedSwatch.classList.add('variant-swatch--selected');
      }
    }

    syncSwatchSelection(variantID) {
      const selectedSwatch = this.querySelector(`.variant-swatch[data-variant-id="${variantID}"]`);
      
      if (selectedSwatch) {
        this.updateSwatchSelection(selectedSwatch);
      } else {
        const allSwatches = this.querySelectorAll('.variant-swatch');
        allSwatches.forEach(swatch => {
          const swatchVariantId = swatch.getAttribute('data-variant-id');
          if (swatchVariantId && swatchVariantId.toString() === variantID.toString()) {
            this.updateSwatchSelection(swatch);
          }
        });
      }
    }

    updateQueryString(key, value, url) {
      let newUrl = url || window.location.href;

      let updated = "";
      const re = new RegExp(`([?&])${key}=.*?(&|#|$)(.*)`, "gi");
      let hash;

      if (re.test(newUrl)) {
        if (typeof value !== "undefined" && value !== null) {
          updated = newUrl.replace(re, `$1${key}=${value}$2$3`);
        } else {
          hash = newUrl.split("#");
          newUrl = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
          if (typeof hash[1] !== "undefined" && hash[1] !== null) {
            newUrl += `#${hash[1]}`;
          }
          updated = newUrl;
        }
      } else if (typeof value !== "undefined" && value !== null) {
        const separator = newUrl.indexOf("?") !== -1 ? "&" : "?";
        hash = newUrl.split("#");
        newUrl = `${hash[0] + separator + key}=${value}`;
        if (typeof hash[1] !== "undefined" && hash[1] !== null) {
          newUrl += `#${hash[1]}`;
        }
        updated = newUrl;
      } else {
        updated = newUrl;
      }

      window.history.replaceState({ path: updated }, "", updated);
    }
  }
  customElements.define("variant-selectors", VariantSelectors);
})();
